module.exports = __webpack_public_path__ + "img/logo.2118fb85.png";